export const meta = {
  id: 'M01',
  slug: 'acessar-mentorados',
  title: 'Como acessar seus Mentorados',
  description: 'Encontre sua carteira de mentorados e abra a visão individual da pessoa que você acompanha.',
  profile: 'mentor',
  category: 'mentorados',
  type: 'task',
  status: 'published',
  order: 220,
  keywords: ['mentorados', 'carteira', 'meus mentorados', 'aluno', 'mentorado', 'acesso'],
  previous: 'M00',
  next: 'M02',
  related: ['M02', 'M07', 'A12'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como acessar seus Mentorados

A área **Meus Mentorados** reúne as pessoas que estão vinculadas ao seu acompanhamento no Personagrama.

## Como acessar

<Steps>
  <Step title="Entre na área do Mentor">
    Abra a navegação destinada ao seu papel de Mentor.
  </Step>
  <Step title="Acesse Meus Mentorados">
    Consulte a lista de pessoas vinculadas a você.
  </Step>
  <Step title="Escolha o mentorado">
    Abra a pessoa que deseja acompanhar para acessar sua visão individual.
  </Step>
  <Step title="Use as informações de contexto">
    A partir da visão do mentorado, consulte desenvolvimento, Plano, Jornada, Formações, Evidências e Mentorias conforme sua permissão.
  </Step>
</Steps>

<Callout type="important">
  Ter o papel de Mentor não libera automaticamente o acesso a todos os alunos. O acesso depende do vínculo de Mentoria ativo entre você e o mentorado.
</Callout>

<HelpImage alt="Carteira de mentorados do Mentor" pendingId="M01.1" />
